module.exports = __webpack_public_path__ + "img/关于我们图片.0e622138.png";